<template>
    <div>
        <breadCrumb 
            :icon="'fa-money-check-edit-alt'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_branding`)"
            :subSubCategory="$t(`brand_submenu.brand_setup_payment`)">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('branding.header_payment')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <form @submit.prevent="submitBrandPayment" class="p-3">
                            <div class="row">
                                <div class="col-lg-6 col-xl-6 p-3 border-right">
                                    <div class="form-group" v-for="(payment, index) in payments.slice(0,5)" :key="index">
                                        <label class="form-label">{{$t('label.payment_option')}} {{index + 1}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.payment_option') + (index + 1)" v-model="payments[index]">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-6 p-3">
                                    <div class="form-group" v-for="(payment, index) in payments.slice(4,9)" :key="index">
                                        <label class="form-label">{{$t('label.payment_option')}} {{index + 6}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.payment_option') + (index + 6)" v-model="payments[index + 5]">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-left mb-3">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'brandPayment',
    components:{
        BreadCrumb
    },
    data(){
        return{
            payments: []
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.getBrandPayment();
            }
            this.$parent.isModalShow = false;
        },
        submitBrandPayment(){
            let $vm = this
            this.$axios({
                method: 'post', 
                url: this.$api.BRAND_PAYMENT,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: {payments: this.payments}
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.my_salon_branding') + $vm.$i18n.t('brand_submenu.brand_setup_payment') + $vm.$i18n.t('message.success.update');
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        getBrandPayment(){
            let $vm = this;
            $vm.payments = []
            $vm.titles = []

            $vm.$axios({
                method: 'get', 
                url: $vm.$api.BRAND_PAYMENT,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.payments = response.data.payments;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        }
    },
    mounted(){
        let $vm = this;
        $vm.getBrandPayment();
    }
}
</script>

